import { TreeView } from '../components/main-filters/more-filter-popup/actuation-filter/action-type-tree-view/action-type-tree-view.component';


export class ActuationSelectionFilter {
    EmpresaID: number;
    CommonDateFrom = '';
    CommonDateTo = '';
    IsActuacion = false;
    IsRegistro = false;
    IsSoloBajasActivas = false;
    Orden = '0';
    RegistroDateFrom = '';
    RegistroDateTo = '';
    Usuario = '';
    FechaRevisionDateFrom = '';
    FechaRevisionDateTo = '';
    Coordinador = '';
    EmpresaCoordinador = ''
    Gestor = '';
    IsRevisadas: boolean;
    IsConComentarios: boolean;
    IsConOrdenes: boolean;
    FacturacionRadioButton: string;
    IsConceptosFacturables: boolean;
    FacturacionFraCentro: string;
    ActivityTypes = new Array<TreeView>();
    AttributeList = [];
    PeriodoDeBajaDateFrom = '';
    PeriodoDeBajaDateTo = '';
    LeaveType = '';
    CoordinatorMain = '';
    IsRevisar: boolean;
    PageIndex = 0;
    PageSize = 0;
    Autor = '';
    AutorMultiple = new Array<number>();
    TipoAutor: string;
    MedicoId: number;
    Trabajador: string;
    ColumnsList:any;
    EmpresaSelec:boolean;
    Proyecto: string;
    Provincia: string;
    Poblacion: string;

}
